export const getAuthReducer = (state) => state.auth;
export const getLoginError = (state) => getAuthReducer(state).loginError;
export const getSignupError = (state) => getAuthReducer(state).signupError;
export const getAuthUserData = (state) => getAuthReducer(state).user_data;
export const getAccountType = (state) => getAuthReducer(state).accountType;

export const checkPinAuthRequired = (state) => getAuthReducer(state)?.pinAuth?.required;
export const selectPinAuthLoading = (state) => getAuthReducer(state)?.pinAuth?.loading;
